import { RxTextCompositeComponent, RxVideoCompositeComponent } from '@nrwl/rx-forms';

import { DialogsConfigService } from '../dialogs-config.service';
import { Doctor } from '@nrwl/rx-models';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TeamDialogConfigService extends DialogsConfigService {
  constructor() {
    super();
  }

  public createEmployee() {
    return {
      payload: {
        title: 'Add Employee',
        tip: 'Please complete the required fields below to add a new employee',
        buttons: this.SubmitDismissButtons('Save and Send Login Credentials', 'Cancel'),
      },
    };
  }

  public disableCreateEmployee() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'EMR Restriction',
        tip: `You are accessing your account through an integrated partner. Please manage your team with your integrated partner or contact your account administrator`,
        buttons: this.DismissButton(),
      },
    };
  }

  public deselectAllConfirmation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: '[TODO Message]: Do you want to deselect all items?',
        tip: '[TODO Description]: Explanatory message',
        buttons: this.SubmitDismissButtons('Yes', 'No'),
      },
    };
  }

  public confirmResetChanges() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm changes',
        tip: 'Unsaved changes may be lost',
        buttons: this.SubmitDismissButtons('Proceed', 'Cancel'),
      },
    };
  }

  public confirmDeactivate() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirmation required',
        tip: 'Are you sure you want to inactivate this user?',
        buttons: this.SubmitDismissButtons('Inactivate User'),
      },
    };
  }

  public confirmActivation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirmation required',
        tip: 'Are you sure you want to activate this user?',
        buttons: this.SubmitDismissButtons('Activate User'),
      },
    };
  }

  public confirmResetPassword(doctor: Doctor) {
    const username = doctor.username;

    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Reset Password for Selected Employee?',
        tip:
          `New password will be emailed to ${username}. ` +
          'Please check spam folder if email has not been received within 30 minutes',
        buttons: this.SubmitDismissButtons('Reset Password'),
      },
    };
  }

  public confirmRestore() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: '[TODO Message]: Do you want to restore a product?',
        tip: '[TODO Description]: Explanatory message',
        buttons: this.SubmitDismissButtons('Restore'),
      },
    };
  }

  public confirmLeavingPage() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Confirm Navigation',
        tip: 'You have unsaved changes. Are you sure you want to leave this page?',
        buttons: this.SubmitDismissButtons('Leave this Page', 'Stay on this Page'),
      },
    };
  }

  public permissions() {
    return {
      width: '1000px',
      payload: {
        title: 'Permission Structure',
        buttons: this.SubmitButton('Done'),
      },
    };
  }

  public employeeExplanation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'What is an Employee?',
        tip: "Employee is an somebody that has unique credentials to access to your clinic's RxPhoto account.",
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public globalSettingsExplanation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'What are Global Settings?',
        tip: 'Global settings are any customizable feature inside the RxPhoto Administration page.',
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public IPRestrictionsExplanation() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'What are IP Restrictions?',
        tip:
          'Users(not managers and administrators) can be resticted based on their IP. ' +
          'Meaning that an administator can create predetermined IP Addresses that users are ' +
          'allowed to access RxPhoto from an IP address that is not on the list, they will not have entry. \n\n' +
          'To enable this feature, please go to Administation -> Whitelist IP Addresses. ' +
          'Please note that if your practice has dynamic IP addresses where IP addresses change ' +
          'gradually, then every time an IP Address changes, you will have to reset the Whitelisted ' +
          'IP Addresses.',
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public emailExists() {
    return {
      component: RxTextCompositeComponent,
      payload: {
        title: 'Email Already Exists',
        tip:
          'An employee with the same email address already exists. Each employee must have ' +
          "a unique email address. Please update the employee's email address before saving changes",
        buttons: this.SubmitButton('I understand'),
      },
    };
  }

  public helpCenter() {
    return {
      component: RxVideoCompositeComponent,
      payload: {
        title: 'Help Center',
        buttons: this.DismissButton(),
      },
    };
  }
}
